<div class="bnr-page">

  <!-- ── Progress bar ──────────────────────────────── -->
  <div class="bnr-progress" *ngIf="!enregistrementTerminer">
    <div class="bnr-progress__bar"></div>
  </div>

  <!-- ── Page header ───────────────────────────────── -->
  <header class="bnr-header">
    <h1 class="bnr-header__title">
      <span class="bnr-header__icon">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18" />
        </svg>
      </span>
      Image & video
    </h1>
  </header>

  <!-- ── Tab bar ───────────────────────────────────── -->
  <div class="bnr-tabs">
    <div class="bnr-tabs__bar">
      <button type="button" class="bnr-tab" [class.active]="indexActiveTabs === 0" (click)="indexActiveTabs = 0">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <circle cx="8.5" cy="8.5" r="1.5" />
          <path d="M21 15l-5-5L5 21" />
        </svg>
        Image
      </button>
      <button type="button" class="bnr-tab" [class.active]="indexActiveTabs === 1" (click)="indexActiveTabs = 1">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" />
        </svg>
        Vidéo défilent
      </button>
    </div>

    <!-- ══ TAB 0 — Image ══ -->
    <div class="bnr-tab-panel" [class.active]="indexActiveTabs === 0">
      <div class="bnr-split">

        <!-- Left: clickable image preview -->
        <div class="bnr-panel bnr-panel--image">
          <div class="bnr-panel__header">
            <div class="bnr-panel__header-left">
              <span class="bnr-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <circle cx="8.5" cy="8.5" r="1.5" />
                  <path d="M21 15l-5-5L5 21" />
                </svg>
              </span>
              Lien principal
            </div>
            <span class="bnr-hint">Cliquer pour modifier</span>
          </div>
          <div class="bnr-panel__body bnr-panel__body--flush">
            <div class="bnr-img-preview" (click)="openWindowSelectImage()">
              <img id="img-lien-principal" [src]="imgLienPrincipal.File_Content" alt="Lien principal" />
              <div class="bnr-img-preview__overlay">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
                  <circle cx="12" cy="13" r="4" />
                </svg>
                <span>Changer l'image</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: text editors -->
        <div class="bnr-panel bnr-panel--text">
          <div class="bnr-panel__header">
            <div class="bnr-panel__header-left">
              <span class="bnr-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M4 6h16M4 12h16M4 18h7" />
                </svg>
              </span>
              Textes associés
            </div>
            <button type="button" class="bnr-btn bnr-btn--success" [disabled]="!enregistrementTerminer"
              (click)="enregistrerLangue(imgLienPrincipal, imgLienPrincipal.File_Text, imgLienPrincipalTextAnglais)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
              </svg>
              Enregistrer
            </button>
          </div>

          <div class="bnr-panel__body">
            <div class="bnr-editor-block">
              <label class="bnr-editor-label">
                <span class="bnr-lang-badge bnr-lang-badge--fr">FR</span>
                Français
              </label>
              <div class="bnr-editor-box">
                <angular-editor [config]="editorConfig" name="text1" placeholder=" "
                  [(ngModel)]="imgLienPrincipal.File_Text">
                </angular-editor>
              </div>
            </div>

            <div class="bnr-editor-block">
              <label class="bnr-editor-label">
                <span class="bnr-lang-badge bnr-lang-badge--en">EN</span>
                Anglais
              </label>
              <div class="bnr-editor-box">
                <angular-editor [config]="editorConfig" name="tex2" placeholder=" "
                  [(ngModel)]="imgLienPrincipalTextAnglais">
                </angular-editor>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- ══ TAB 1 — Vidéo défilent ══ -->
    <div class="bnr-tab-panel" [class.active]="indexActiveTabs === 1">
      <div class="bnr-split">

        <!-- Left: video list -->
        <div class="bnr-panel bnr-panel--list">
          <div class="bnr-panel__header">
            <div class="bnr-panel__header-left">
              <span class="bnr-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <polygon points="23 7 16 12 23 17 23 7" />
                  <rect x="1" y="5" width="15" height="14" rx="2" />
                </svg>
              </span>
              Vidéos
            </div>
          </div>
          <div class="bnr-panel__body bnr-panel__body--list">
            <app-liste #listeLienEtVideoComponen [showFilter]="false" [heightTable]="'400'"
              [displayedColumnsBrut]="columns" [listBtn]="listBtnLienEtVideo" (btnTable)="clickBtnLienEtVideo($event)">
            </app-liste>
          </div>
        </div>

        <!-- Right: text inputs + save -->
        <div class="bnr-panel bnr-panel--text">
          <div class="bnr-panel__header">
            <div class="bnr-panel__header-left">
              <span class="bnr-panel__icon">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M4 6h16M4 12h16M4 18h7" />
                </svg>
              </span>
              Textes associés
            </div>
            <button type="button" class="bnr-btn bnr-btn--success" [disabled]="!enregistrementTerminer"
              (click)="enregistrerLangue(selectedRow, imgLienEtVideoTextFrancais, imgLienEtVideoTextAnglais)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                <polyline points="17 21 17 13 7 13 7 21" />
              </svg>
              Enregistrer
            </button>
          </div>

          <div class="bnr-panel__body">

            <div class="bnr-field-block">
              <label class="bnr-field-label">
                <span class="bnr-lang-badge bnr-lang-badge--fr">FR</span>
                Français
              </label>
              <input class="bnr-input" name="text4" [(ngModel)]="imgLienEtVideoTextFrancais"
                placeholder="Texte français…" />
            </div>

            <div class="bnr-field-block">
              <label class="bnr-field-label">
                <span class="bnr-lang-badge bnr-lang-badge--en">EN</span>
                Anglais
              </label>
              <input class="bnr-input" name="text5" [(ngModel)]="imgLienEtVideoTextAnglais"
                placeholder="English text…" />
            </div>

          </div>
        </div>

      </div>
    </div>

  </div><!-- /bnr-tabs -->

  <input id="input_file" type="file" style="display:none" (change)="onChangeImagefile($event)" />

  <!-- ── Add-video dialog template ─────────────────── -->
  <ng-template #content>
    <div class="bnr-dialog">
      <div class="bnr-dialog__header">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
          <polygon points="23 7 16 12 23 17 23 7" />
          <rect x="1" y="5" width="15" height="14" rx="2" />
        </svg>
        Ajouter une vidéo
      </div>
      <div class="bnr-dialog__body">
        <div class="bnr-field-block">
          <label class="bnr-field-label">URL de la vidéo</label>
          <input class="bnr-input" name="video-link" [(ngModel)]="urlVideo" placeholder="https://…" />
        </div>
        <div class="bnr-field-block">
          <label class="bnr-field-label">Titre</label>
          <input class="bnr-input" name="video-title" [(ngModel)]="titreVideo" placeholder="Titre…" />
        </div>
        <div class="bnr-field-block">
          <label class="bnr-field-label">Description</label>
          <input class="bnr-input" name="video-desc" [(ngModel)]="descriptionVideo" placeholder="Description…" />
        </div>
      </div>
      <div class="bnr-dialog__footer">
        <button type="button" class="bnr-btn bnr-btn--outline" mat-dialog-close>Annuler</button>
        <button type="button" class="bnr-btn bnr-btn--primary" (click)="ajouterVideo()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Ajouter
        </button>
      </div>
    </div>
  </ng-template>

</div>